import React from 'react';

const Button = (props) => {
  return <button {...props} className={`btn btn-${props.nature || props.type} ${props.modifiers}`}>
			{props.children}
		</button>;
};

export default Button;


// WEBPACK FOOTER //
// ./src/ui/Button.js